<template>
  <div class="animated fadeIn">
    <Row>
      <Input v-model="keywordFilter" placeholder="角色名/昵称" style="width: 200px; margin-right: 10px;"></Input>
      <Button type="primary" style="margin-right: 10px;" @click="onFilterClick">查询</Button>
      <Button type="primary" @click="addRoleModal=true">添加角色</Button>
    </Row>
    <Row style="margin-top: 10px;">
      <div>
        <div style="position:relative;">
          <Table height="600" :columns="columns" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page :total="totalElements" :page-size="pageSize" :show-total="true" show-elevator @on-change="setPage"
              style="text-align:right;margin-top:10px"></Page>
      </div>
    </Row>

    <!-- 添加角色Modal -->
    <!--<Modal-->
      <!--v-model="addRoleModal"-->
      <!--title="添加角色"-->
      <!--@on-ok="addRoleModal_ok">-->
      <!--<p>角色名：<Input v-model="addRole_Name" placeholder="请输入角色名......"></Input>-->
        <!--<br></p>-->
      <!--<p>昵称：<Input v-model="addRole_NickName" placeholder="请输入昵称......"></Input>-->
        <!--<br></p>-->
      <!--<p>描述：<Input v-model="addRole_Description" placeholder="请输入描述......"></Input>-->
        <!--<br></p>-->
    <!--</Modal>-->

    <set-permission-modal v-model="setPermissionsModal" :initValue="setPermissionsRoleId"></set-permission-modal>
    <add-role-modal v-model="addRoleModal" @on-success="onSuccess"></add-role-modal>
    <role-detail-modal v-model="roleDetailModal" :initValue="roleDetailId" @on-success="onSuccess"></role-detail-modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import store from "../../store"
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"
  import SetPermissionModal from '@/view/acl/components/set-permission-modal'
  import AddRoleModal from '@/view/acl/components/add-role-modal'
  import RoleDetailModal from '@/view/acl/components/role-detail-modal'

  export default {
    name: 'roles',
    components: {
      SetPermissionModal,
      AddRoleModal,
      RoleDetailModal
    },
    data() {
      return {

        //添加角色Modal
        addRoleModal: false,

        //设置权限
        setPermissionsRoleId:null,
        setPermissionsModal:false,

        //详细信息
        roleDetailModal:false,
        roleDetailId:null,

        tableHeight: 160,
        pageindex: 1,
        sort: null,
        listLoadding: false,
        keywordFilter:null,
        columns: [
          {
            title: 'ID',
            key: 'id',
            sortable: 'custom',
            tooltip: 'true',
            minWidth: 100
          },
          {
            title: '角色名',
            key: 'name',
            ellipsis: 'true',
            minWidth: 200
          },
          {
            title: '昵称',
            key: 'nickName',
            ellipsis: 'true',
            minWidth: 200
          },
          {
            title: '状态',
            ellipsis: 'true',
            minWidth: 120,
            filters: [
              {
                label: '冻结',
                value: 1
              },
              {
                label: '正常',
                value: 2
              }
            ],
            filterMultiple: false,
            filterMethod(value, row) {
              if (value === 1) {
                return row.deleted === true;
              } else if (value === 2) {
                return row.deleted === false;
              }
            },
            render: (h, params) => {
              const task_status = params.row.deleted;
              if (task_status === false)
                return h('div', [
                  h('Tag', {
                    props: {
                      type: 'dot',
                      color: "green"
                    }
                  }, "正常"),
                ]);

              else if (task_status === true)
                return h('div', [
                  h('Tag', {
                    props: {
                      type: 'dot',
                      color: "red"
                    }
                  }, "冻结"),
                ]);
            }
          },
          {
            title: '操作',
            key: 'action',
            align: 'left',
            ellipsis: 'true',
            minWidth: 200,
            render: (h, params) => {
              const task_status = params.row.deleted;
              if (task_status === false) {
                return h('div', [
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false,
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.setPermissionsRoleId = params.row.id
                        this.setPermissionsModal = true
                      }
                    }
                  }, '设置权限'),
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false,
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.roleDetailId = params.row.id
                        this.roleDetailModal = true
                      }
                    }
                  }, '详细信息')
                ]);
              } else if (task_status === true) {
                return h('div', [
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.onActiveBtnClick(params.row.id);
                      }
                    }
                  }, '激活')
                ]);
              }
            }//render
          },//{
        ],//cloumn
      }//return
    },//data
    methods: {
      addRoleModal_ok() {
        this.$Modal.confirm({
          title: '确认添加角色',
          content: '<p>确认添加此角色</p>',
          onOk: () => {
            store.dispatch('RoleServ_AddObj', {
              params: {
                name: this.addRole_Name,
                nickName: this.addRole_NickName,
                description: this.addRole_Description
              }
            }).then(() => {
              this.refreshPage();
            }).catch(err => {
              this.$Message.error(err);
            });
          },
          onCancel: () => {
          }
        });
      },
      onSuccess(){
        this.setPage(1)
      },
      onFilterClick(){
        this.setPage(1)
      },
      sortChange({column, key, order}) {
        this.sort = {
          name: key,
          asc: order === 'asc' ? true : false
        }
        this.refreshPage();
      },
      setPage(page) {
        this.pageindex = page;
        this.listLoadding = true;

        let sortParam = null;

        if (this.sort !== null && this.sort !== undefined) {
          sortParam = genSortParam(this.sort.name, this.sort.asc);
        } else {
          sortParam = genSortParam('id', false);
        }

        store.dispatch('RoleServ_GetPage', {
          params: null,
          urlparams: {
            p: page,
            keyword: this.keywordFilter,
            sort: sortParam
          }
        }).then(() => {
          this.listLoadding = false;
        }).catch(err => {
          this.listLoadding = false;
          this.$Message.error(err);
        });
      },
      //刷新当前页
      refreshPage() {
        this.setPage(this.pageindex)
      }
    },
    computed: {
      totalElements() {
        if (store.getters.get_Role_GetPageResult) {
          return store.getters.get_Role_GetPageResult.totalElements;
        } else {
          return 0;
        }

      },
      content() {
        if (store.getters.get_Role_GetPageResult) {
          return store.getters.get_Role_GetPageResult.content;
        } else {
          return [];
        }

      },
      pageSize() {
        if (store.getters.get_Role_GetPageResult) {
          return store.getters.get_Role_GetPageResult.size;
        } else {
          return 0;
        }

      }
    },
    mounted() {
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 230;
        this.setPage(1);
      });
    },
  }
</script>

<style scoped>
</style>
